module.exports = __webpack_public_path__ + "static/bg_Video-4f5766d9a3b732238a0bd5598c61adba.png";